export default "__VITE_ASSET__Dx43cPYL__"